/**
 * Convert backend data to a format that is easier to work with our
 * custom form generator.
 */

interface IFormSchemaIn {
  default: string
  description: string
  type: string
  format?: string
  items?: {
    required?: string[]
  }
}

export interface IFormSchemaOutput {
  default_: string
  description: string
  inputType: string
  format?: string
  key: string
  name: string
  isRequired: boolean
  _: IFormSchemaOutput[]
}

// @ts-ignore
export const convertDataConsumableByForm = (data: any): IFormSchemaOutput[] => {
  let modSchema: any[] = []
  let formSchema = {}
  let required_: string[] | undefined = []

  //FIXME: Payload from backend needs to be consistent
  // Guard against schemas without `properties`/`required` (e.g. arrays of
  // primitives like a list of strings/numbers). Spreading an undefined
  // `required` throws and, because this runs in a useEffect outside the
  // ErrorBoundary, would blank the whole page.
  if (data.items) {
    formSchema = {
      ...(data.items.properties ?? {}),
    }
    required_ = data.items.required ? [...data.items.required] : []
  } else {
    formSchema = {
      ...(data.properties ?? {}),
    }
    required_ = data.required ? [...data.required] : []
  }

  for (let [key, _value] of Object.entries(formSchema)) {
    const value = <IFormSchemaIn>_value
    const { type: type_, description, default: default_, format } = value

    if (type_ !== "array") {
      const re = {
        key,
        name: key,
        description,
        inputType: type_,
        format,
        default_,
        isRequired: required_?.includes(key),
      }
      modSchema.push(re)
    } else {
      required_ = value.items?.required
      modSchema = [
        ...modSchema,
        {
          key,
          name: key,
          description,
          inputType: "_nested_",
          default_: null,
          [key]: convertDataConsumableByForm(value),
        },
      ]
    }
  }

  /**
   * Let's rearrange properties so that all unnested input's comes first
   * followed by nested
   */
  let nested: any[] = []
  let unNested: any[] = []
  modSchema.map((schema) => {
    if (schema.inputType === "_nested_") {
      nested.push(schema)
    } else {
      unNested.push(schema)
    }
  })
  return [...unNested, ...nested]
}
